import { render, staticRenderFns } from "./EditModeBoard.vue?vue&type=template&id=e6e69c7a&scoped=true&"
import script from "./EditModeBoard.vue?vue&type=script&lang=js&"
export * from "./EditModeBoard.vue?vue&type=script&lang=js&"
import style0 from "./EditModeBoard.vue?vue&type=style&index=0&id=e6e69c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e69c7a",
  null
  
)

export default component.exports